import { api } from './api'
import type { PlayerStats } from '@acepoker/contract'

export const getPlayerStats = async (
  playerId: string,
  game?: string,
  filter?: string
): Promise<PlayerStats> => {
  const baseUrl = `/api/analysis/player/${playerId}/stat`
  const params = new URLSearchParams()

  if (game) {
    params.append('game', game)
  }

  if (filter) {
    params.append('filter', filter)
  }

  const endpoint = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl
  const response = await api().get(endpoint).json<PlayerStats>()
  return response
}
